<template>
  <oie-my-pages-template :title="t('addNewMachineTitle')" :text="t('addNewMachineSubTitle')" :with-go-back="true">
    <oie-add-edit-machine-form @cancel="goBack()" @save="handleSave($event)"></oie-add-edit-machine-form>
  </oie-my-pages-template>
</template>

<script>
import myPages from '@/mixins/my-pages'
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  mixins: [myPages],
  methods: {
    ...mapActions('myMachines', ['setCurrentMachine', 'getMyMachines', 'updateMachinesForOwner']),
    handleSave($event) {
      const cameFromMachineOwner = _.isEqual(_.nth(this.navigationHistory, -2), this.navigationOptions.oieMachineOwnerDetails)
      if(cameFromMachineOwner) {
        this.updateMachinesForOwner($event)
        this.goBack()
      } else {
        this.setCurrentMachine($event)
        this.goToSubPage(this.navigationOptions.oieMachineDetails)
      }
    }
  }
}
</script>
